import React from 'react'

export const PATIENT = 'PATIENT'
export const ADMIN = 'ADMIN'
export const EXPERT = 'EXPERT'
export const PROVIDER = 'PROVIDER'

 export const UserRoles = [PATIENT, ADMIN, EXPERT, PROVIDER]